module.exports = __webpack_public_path__ + "static/media/login_bg.b165084d.png";